var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { styledComponents } from '@datashop/theme';
var styled = styledComponents.default, withProps = styledComponents.withProps;
var Wrapper = withProps(styled.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 16px;\n  display: flex;\n  justify-content: flex-end;\n  flex-grow: 0;\n  border-top:  ", ";\n\n  > * {\n    margin-left: 8px;\n  }\n"], ["\n  padding: 16px;\n  display: flex;\n  justify-content: flex-end;\n  flex-grow: 0;\n  border-top:  ",
    ";\n\n  > * {\n    margin-left: 8px;\n  }\n"])), function (props) {
    return !!props.bordered
        ? "1px solid " + props.theme.datashop.palette.stone.light
        : 'none';
});
var Footer = (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.render = function () {
        var _a = this.props, bordered = _a.bordered, children = _a.children, rest = __rest(_a, ["bordered", "children"]);
        return (React.createElement(Wrapper, __assign({}, rest, { bordered: bordered }), children));
    };
    return Footer;
}(React.PureComponent));
export default Footer;
var templateObject_1;
//# sourceMappingURL=footer.js.map